// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.tracking.RentalManagerUserTrackingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, RentalManagerUserTrackingEvent } from '../..';

interface EventParams {
  trackingEvent: RentalManagerUserTrackingEvent;
}
interface ListingParams {
  listingAlias: ListingAlias;
  trackingEvent: RentalManagerUserTrackingEvent;
}
interface LogParams {
  description?: string;
  id: string;
}

export const RentalManagerUserTrackingWebApiHandler_event_Path = '/api/web/v1/users/tracking/event';

/**
 * Track event
 * @deprecated
 */
export const RentalManagerUserTrackingWebApiHandler_event = (getParams: EventParams, client = getClient()) => {
  return httpFrontEndRequest<EventParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserTrackingWebApiHandler_event_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserTrackingWebApiHandler_listing_Path = '/api/web/v1/users/tracking/listing';

/**
 * Track listing event
 * @deprecated
 */
export const RentalManagerUserTrackingWebApiHandler_listing = (getParams: ListingParams, client = getClient()) => {
  return httpFrontEndRequest<ListingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserTrackingWebApiHandler_listing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserTrackingWebApiHandler_log_Path = '/api/web/v1/users/tracking/log';

/**
 * Log events for debugging purposes
 * @deprecated
 */
export const RentalManagerUserTrackingWebApiHandler_log = (getParams: LogParams, client = getClient()) => {
  return httpFrontEndRequest<LogParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserTrackingWebApiHandler_log_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
